// extracted by mini-css-extract-plugin
export var orderDetails = "_p9-2";
export var orderImage = "_p9-1";
export var orderMeta = "_p9-3";
export var orderSummary = "_p9-0";
export var rightArrow = "_p9-4";